import { Box, List } from '@mui/material';
import { PageContainer } from '../../containers/PageContainer/PageContainer';
import { Copy } from '../../copy/Copy';
import { ChatGPT } from '../../icons/ChatGPT/ChatGPT';
import {
  coachContainerSx,
  marginRight8Sx,
  padding12Sx,
} from '../../styles/Global.style';
import { useNavigate } from 'react-router-dom';
import { APP_PATHS } from '../../constants/paths';
import { GPT } from '../../components/GPT/GPT';
import { ListItemTile } from '../../components/ListItemTile/ListItemTile';
import { COACH_LIST_ITEMS } from '../../constants/coach';
import { useState } from 'react';
import { Fade } from '../../components/Fade/Fade';

export const Coach = () => {
  const navigate = useNavigate();
  const [isIn, setIsIn] = useState();

  return (
    <PageContainer
      title={Copy.generate('Global.coach')}
      logo={<ChatGPT sx={marginRight8Sx} />}
    >
      <Box component="div" sx={coachContainerSx}>
        <GPT
          height={170}
          typeString={Copy.generate('GPT.welcome')}
          callback={() => setIsIn(true)}
        />

        <List sx={padding12Sx}>
          {COACH_LIST_ITEMS.sort(() => 0.5 - Math.random())[0].options.map(
            (l, i) => (
              <Fade isIn={isIn} i={i} key={i}>
                <ListItemTile
                  key={i}
                  text={Copy.generate(`GPT.prompts.${l.name}`)}
                  icon={l.icon}
                  onClick={() =>
                    navigate(APP_PATHS.coachResponse, {
                      state: { prompt: Copy.generate(`GPT.prompts.${l.name}`) },
                    })
                  }
                />
              </Fade>
            ),
          )}
        </List>
      </Box>
    </PageContainer>
  );
};
